// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mVoo-","footer":"styles_footer__1YpQV","passCodeTooltip":"styles_passCodeTooltip__5VKaP"};